import Image from 'next/image'
import React, { useMemo, useState } from 'react'

import { useRouter } from 'next/router'
import { useTranslation } from 'src/utils/i18n'
import { Icon } from '@iconify/react'

function Index() {
  const [isOpen, setIsOpen] = useState(false)
  const [isOpen2, setIsOpen2] = useState(false)

  const router = useRouter()

  const { t } = useTranslation('commonAndroid')

  return (
    <div
      className={`bg-[#fff] Sixmd:border-t-[1px] Blds:shadow-step relative Local-step Sixmds:rounded-[10px] ${!isOpen && !isOpen2 ? '' : 'pb-[50px]'
        }`}
    >
      <div className='w-[610px] Bld:w-[90%] mx-auto'>
        <div className='pt-[54px]'>
          <p className='text-center text-[48px] font-[600] Bld:text-[26px] Bld:leading-[40px] leading-[54px]'>
            {t('Choose the device you wish to monitor')}.
          </p>
          <p className='text-center mt-[24px] text-[16px] xs:text-[14px] font-[600] w-[430px] text-[#2F343C] xs:w-[96%] mx-auto'>
            {t('Msafely will provide you with a customized solution!')}
          </p>
        </div>

        <div className='mt-[30px] w-full Bld:mt-[25px] mx-auto Blds:flex Bld:grid items-center justify-center'>
          <button
            onClick={() => {
              localStorage.setItem('platform', 'iOS-Cloud'),
                router.push(`/android/step/checkout/${localStorage.getItem('ProductID')}`)
            }}
            className={`w-[230px] h-[220px] items-center justify-center choose-device-button Bld:h-[110px] border-[1px] border-[#12D8AB] hover:border-none rounded-[12px] Bld:rounded-[8px] flex relative z-40 hover:shadow-choose active:shadow-choose bg-ios-step bg-cover hover:bg-ios-step-1 hover:bg-[#B8F3E6]`}
          >
            <div className='grid items-center justify-center mx-auto'>
              <Image
                alt='ios'
                width={100}
                height={100}
                src='/images/android/ios.svg'
                className='w-[64px] h-[75px] mx-auto Bld:w-[40px] Bld:h-full'
              />
              <p className='font-[600] text-[26px] Bld:text-[19px] flex items-center justify-center text-black ml-4 mt-[20px] Bld:mt-[10px] select-none'>
                iPhone
                <Icon
                  icon='mingcute:right-line'
                  className='text-black ml-2 w-[26px] h-[26px] Bld:w-[20px] Bld:h-[20px]'
                />
              </p>
            </div>
          </button>

          <button
            onClick={() => {
              localStorage.setItem('platform', 'Android-Cloud'),
                router.push(`/android/step/checkout/${localStorage.getItem('ProductID')}`)
            }}
            className={`w-[230px] h-[220px] Blds:ml-[24px] Bld:mt-[30px] items-center justify-center choose-device-button Bld:h-[110px] border-[1px] border-[#12D8AB] hover:border-none rounded-[12px] Bld:rounded-[8px] flex relative z-40 hover:shadow-choose bg-android-step bg-cover hover:bg-android-step-1 hover:bg-[#B8F3E6]`}
          >
            <div className='grid items-center justify-center mx-auto'>
              <Image
                alt='ios'
                width={100}
                height={100}
                src='/images/android/android.svg'
                className='w-[64px] h-[75px] mx-auto Bld:w-[40px] Bld:h-full'
              />
              <p className='font-[600] text-[26px] Bld:text-[19px] flex items-center justify-center text-black ml-6 mt-[20px] Bld:mt-[10px] select-none'>
                Android
                <Icon
                  icon='mingcute:right-line'
                  className='text-black ml-2 w-[26px] h-[26px] Bld:w-[20px] Bld:h-[20px]'
                />
              </p>
            </div>
          </button>
        </div>
      </div>

      <button onClick={() => (router.push('/android/step/pricing'))} className='absolute right-4 top-4'>
        <Icon icon='akar-icons:cross' className='w-[24px] h-[24px] text-black/40' />
      </button>
    </div>
  )
}

export default Index
